import { useSearchParams } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { PageHero } from "@/components/sections/PageHero";
import { LeadSection } from "@/components/sections/LeadSection";
import { MachineCard } from "@/components/machines/MachineCard";
import { CATEGORIES, MACHINES, IMG } from "@/data/site";
import { EASE } from "@/components/motion/Reveal";
import { cn } from "@/lib/utils";

const TABS = [{ slug: "all", title: "All Equipment" }, ...CATEGORIES];

export default function Equipment() {
  const [params, setParams] = useSearchParams();
  const active = params.get("category") || "all";
  const list = active === "all" ? MACHINES : MACHINES.filter((m) => m.category === active);
  const cat = CATEGORIES.find((c) => c.slug === active);

  return (
    <div data-testid="equipment-page">
      <PageHero testId="equipment-hero" eyebrow="Equipment" lines={["Commercial", "Equipment"]} img={IMG.arcadeRoom} sub="Arcade games, claw and prize machines, jukeboxes, pool tables, ATMs and more — selected for your location and supported by Brewer." />
      <section className="py-20 lg:py-28">
        <div className="container-x">
          <div className="flex flex-wrap gap-2" role="tablist">
            {TABS.map((t) => (
              <button key={t.slug} role="tab" aria-selected={active === t.slug} onClick={() => setParams(t.slug === "all" ? {} : { category: t.slug }, { preventScrollReset: true })} className={cn("relative rounded-full border px-5 py-2.5 text-sm transition-colors duration-300", active === t.slug ? "border-volt text-ink-950" : "border-white/15 text-slate-300 hover:border-white/40")} data-testid={`equipment-filter-${t.slug}`}>
                {active === t.slug && <motion.span layoutId="eq-tab" className="absolute inset-0 rounded-full bg-volt" transition={{ duration: 0.5, ease: EASE }} />}
                <span className="relative">{t.title}</span>
              </button>
            ))}
          </div>
          <p className="mt-8 max-w-2xl text-slate-400" data-testid="equipment-filter-description">{cat ? cat.desc : "Browse popular equipment Brewer places and services. Don't see exactly what you need? Ask — we'll find it."}</p>
          <motion.div layout className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            <AnimatePresence mode="popLayout">
              {list.map((m, i) => (
                <motion.div key={m.id} layout initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, scale: 0.96 }} transition={{ duration: 0.6, ease: EASE, delay: i * 0.04 }}>
                  <MachineCard m={m} className="h-full" />
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>
        </div>
      </section>
      <LeadSection index="02" source="equipment-page" />
    </div>
  );
}
